import { Component, OnInit } from '@angular/core';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { RouterLink } from '@angular/router';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { QuillEditorComponent } from 'ngx-quill';
import { QuillA11yDirective } from '../_shared/directives/quill-a11y.directive';
import { CreateSchoolService, MISSING_DEFAULT_CONTENT_MESSAGE } from '../_services/create-school.service';
import { SchoolContent } from '../_services/create-school.builder';

@Component({
  selector: 'app-default-content',
  templateUrl: './default-content.component.html',
  styleUrls: ['./default-content.component.css'],
  imports: [ReactiveFormsModule, RouterLink, MatButton, MatIcon, QuillEditorComponent, QuillA11yDirective],
})
export class DefaultContentComponent implements OnInit {
  state: 'loading' | 'ready' | 'saving' | 'saved' | 'error' = 'loading';
  errorMessage = '';
  statusMessage = '';
  readonly modules = {
    clipboard: { matchVisual: false },
    toolbar: [
      ['bold', 'italic', 'underline', 'strike'],
      [{ list: 'ordered' }, { list: 'bullet' }],
      [{ header: [1, 2, 3, false] }],
      ['link'],
      ['clean'],
    ],
  };

  readonly form = this.fb.nonNullable.group({
    welcomeIntro: [''],
    welcomeDisclaimer: [''],
    nextSteps: [''],
    schoolQuestionHeader: [''],
  });

  constructor(
    private title: Title,
    private fb: FormBuilder,
    private createSchoolService: CreateSchoolService,
  ) {
    this.title.setTitle('Default content | NPC Admin');
  }

  async ngOnInit(): Promise<void> {
    try {
      const content = await this.createSchoolService.loadDefaultContent();
      this.form.patchValue(content);
      this.state = 'ready';
    } catch (err) {
      console.error('Failed to load default content', err);
      this.errorMessage = err instanceof Error ? err.message : MISSING_DEFAULT_CONTENT_MESSAGE;
      this.state = 'ready';
    }
  }

  async save(): Promise<void> {
    this.state = 'saving';
    this.errorMessage = '';
    this.statusMessage = '';
    const content: SchoolContent = this.form.getRawValue();
    try {
      await this.createSchoolService.saveDefaultContent(content);
      this.statusMessage = 'Default content saved. New schools will use this copy.';
      this.state = 'saved';
    } catch (err) {
      console.error('Failed to save default content', err);
      this.errorMessage = 'Unable to save default content.';
      this.state = 'error';
    }
  }
}
